var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},[_c('section',[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-modal',{attrs:{"id":"modal-1","title":"Join Our Beta"}},[_c('Mailchimp')],1)],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }